/**
 * 表格时间格式化
 *	@param {Date|time} cellValue
 *  @return {String} 00/00/00
 */
 export function formatDate(cellValue) {
  if (cellValue == null || cellValue == "") return "";
  var date = new Date(cellValue)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  return year + '/' + month + '/' + day
}

export function isMobile() {
  const userAgent = window.navigator.userAgent;
  if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
    return true;
  } else {
    return false;
  }
}